import React from 'react';
import {
  PLATFORM_ICONS,
  PLATFORM_STATIC_ICONS
} from '../../../../config/icons';

interface LomavisPostPreview1Props {
  image: string;
  text: string;
  platforms: string[]; // e.g., ['facebook', 'instagram']
  date: string; // formatted date string
}

const LomavisPostPreview1: React.FC<LomavisPostPreview1Props> = ({
  image,
  text,
  platforms,
  date
}) => {
  return (
    <div className="border rounded p-2 bg-white d-flex border-secondary">
      <img
        src={image}
        alt="Post Preview"
        className="rounded me-2"
        style={{ width: '60px', height: '60px', objectFit: 'cover' }}
      />
      <div className="flex-grow-1 d-flex flex-column justify-content-between">
        <p
          className="mb-1 small text-muted text-truncate"
          style={{ maxWidth: '100%' }}
        >
          {text}
        </p>
        <div className="d-flex justify-content-between align-items-center">
          <div>
            {platforms.map((platform) => (
              <img
                key={platform}
                src={PLATFORM_STATIC_ICONS[platform]}
                alt={platform}
                className="me-1"
                style={{ width: '20px', height: '20px' }}
              />
            ))}
          </div>
          <small className="text-muted">{date}</small>
        </div>
      </div>
    </div>
  );
};

export default LomavisPostPreview1;
